import { Suspense, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { lazyPage } from '@/lib/lazy-page';
import { closePageDialog, closeWebDialog, requestClosePageDialog, useLinkDialogStore } from './link-dialog-store';
import { WebLinkDialog } from './WebLinkDialog';

// Loaded the first time a link opens it: it brings the pages' routes and the task view.
const PageLinkDialog = lazyPage(() => import('./PageLinkDialog'));

/**
 * The link dialogs (SF-T-160), once in the app shell: a factory page, and over it a web page, opened
 * from links in the chat and task comments (LinksOpenInDialogs).
 */
export function LinkDialogHost() {
  const page = useLinkDialogStore((s) => s.page);
  const web = useLinkDialogStore((s) => s.web);
  // Going to another page (the sidebar, Go to this page) leaves the dialogs behind.
  const { pathname } = useLocation();
  const shownOn = useRef(pathname);
  useEffect(() => {
    if (shownOn.current === pathname) return;
    shownOn.current = pathname;
    closePageDialog();
    closeWebDialog();
  }, [pathname]);
  return (
    <>
      {page ? (
        <ErrorBoundary variant="section" title="This link’s dialog stopped working">
          <Suspense fallback={null}>
            <PageLinkDialog key={page.key} path={page.path} baseSlug={page.baseSlug} onClose={() => void requestClosePageDialog()} />
          </Suspense>
        </ErrorBoundary>
      ) : null}
      {web ? <WebLinkDialog url={web} onClose={closeWebDialog} /> : null}
    </>
  );
}
